import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { JobType } from '@app/features/job-types/job-type.model';
import {
  SalaryScaleDialog,
  SalaryScaleDialogData,
} from '@app/features/salary/salary-scale-dialog/salary-scale-dialog';
import { SalaryScale } from '@app/features/salary/salary-scale.model';

@Injectable({
  providedIn: 'root',
})
export class SalaryScaleUiService {
  dialog = inject(MatDialog);

  openEditSalaryScaleDialog(
    jobType: JobType,
    salaryScale: SalaryScale,
    disableClose = true,
  ): MatDialogRef<SalaryScaleDialog, SalaryScale> {
    return this.dialog.open<SalaryScaleDialog, SalaryScaleDialogData, SalaryScale>(
      SalaryScaleDialog,
      {
        width: '80%',
        minWidth: '230px',
        maxWidth: '512px',
        disableClose: disableClose,
        data: { jobType, editSalaryScale: salaryScale },
      },
    );
  }
}
